<template>
  <div class="project-gstc-gantt">
    <GanttView :lists="lists" :table="list" :projectid="projectid" :menuWidth="940" :itemWidth="80"
      @on-change="updateTime" @on-click="clickItem" />
    <!-- <el-dropdown class="project-gstc-dropdown-filtr" @command="tapProject">
      <i class="el-icon-s-operation project-gstc-dropdown-icon" :class="{ filtr: filtrProjectId > 0 }" />
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :command="0" :class="{ 'dropdown-active': filtrProjectId == 0 }">{{ '全部' }}</el-dropdown-item>
        <el-dropdown-item v-for="(item, index) in projectLabel" :key="index" :command="item.taskid"
          :class="{ 'dropdown-active': filtrProjectId == item.taskid }">{{ item.title }} ({{ item.taskLists.length }})
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown> -->
    <div class="project-gstc-edit" :class="{ info: editShowInfo, visible: editData.length > 0 }">
      <div class="project-gstc-edit-info">
        <el-table class="tableFill" size="medium" max-height="600" :data="editData">
          <el-table-column prop="label" label="任务名称" min-width="150" show-overflow-tooltip> </el-table-column>
          <el-table-column label="原计划时间" min-width="150" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.notime">--</span>
              <span v-else>
                <span>{{ scope.row.backTime.start | parseTime('{y}-{m}-{d} {h}:{i}') }} </span>
                <span>——</span>
                <span>{{ scope.row.backTime.end | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="新计划时间" min-width="150" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.newTime.start | parseTime('{y}-{m}-{d} {h}:{i}') }} </span>
              <span>——</span>
              <span>{{ scope.row.newTime.end | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="project-gstc-edit-btns">
          <el-button :loading="editLoad > 0" size="small" type="text" @click="editSubmit(false)">{{ '取消' }}</el-button>
          <el-button :loading="editLoad > 0" size="small" type="primary" @click="editSubmit(true)">{{ '保存' }}
          </el-button>
          <i class="el-icon-caret-right zoom" @click="editShowInfo = false" />
        </div>
      </div>
      <div class="project-gstc-edit-small">
        <div class="project-gstc-edit-text" @click="editShowInfo = true">{{ '未保存计划时间' }}: {{ editData.length }}</div>
        <el-button :loading="editLoad > 0" size="small" type="text" @click="editSubmit(false)">{{ '取消' }}</el-button>
        <el-button :loading="editLoad > 0" size="small" type="primary" @click="editSubmit(true)">{{ '保存' }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneData } from '@/utils/workteam'
import {
  updateTaskApi,
  sortTaskApi,
  deleteTaskApi,
  getTaskCommentApi,
} from "@/api/pm/taskApi";
/**
 * 甘特图
 */
export default {
  name: 'gatt',
  components: {
    GanttView: () => import('../gatt/GattView.vue')
  },
  props: {
    projectLabel: {
      default: () => {
        return []
      }
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    projectid: {
      type: [Number, String],
      default: null
    }
  },

  data () {
    return {
      loadFinish: false,

      editData: [],
      editShowInfo: false,
      editLoad: 0,

      filtrProjectId: 0
    }
  },
  computed: {
    lists () {
      return this.list.map(taskData => {
        let notime = taskData.starttime == 0 || taskData.endtime == 0
        let times = this.getTimeObj(taskData)
        let start = times.start
        let end = times.end
        //
        let color = '#058ce4'
        if (taskData.status == 100) {
          color = '#c1c1c1'
        } else {
          if (taskData.priority === 1) {
            color = '#ff0000'
          } else if (taskData.priority === 2) {
            color = '#BB9F35'
          } else if (taskData.priority === 3) {
            color = '#449EDD'
          } else if (taskData.priority === 4) {
            color = '#84A83B'
          }
        }
        let tempTime = { start, end }
        let findData = this.editData.find(t => {
          return t.taskid == taskData.taskid
        })
        if (findData) {
          findData.backTime = cloneData(tempTime)
          tempTime = cloneData(findData.newTime)
        }
        return {
          id: taskData.taskid,
          label: taskData.task_title,
          time: tempTime,
          notime: notime,
          style: { background: color }
        }
      })
    }
  },

  watch: {
    list (val) {
      this.initData()
      this.loadFinish = true
    }
  },

  methods: {
    initData () {
      if (this.list.length == 0) {
        this.$confirm('任务列表为空，请先添加任务', '温馨提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          type: 'warning'
        })
          .then(() => {
            this.$emit('on-close')
          })
          .catch(() => { })
      }
    },

    updateTime (item) {
      let original = item.oldtime
      if (Math.abs(original.end - item.endtime) > 1000 || Math.abs(original.start - item.starttime) > 1000) {
        //修改时间（变化超过1秒钟)
        let backTime = cloneData(original)
        let newTime = cloneData({ start: item.starttime, end: item.endtime })
        let findData = this.editData.find(({ id }) => id == item.taskid)
        if (findData) {
          findData.newTime = newTime
        } else {
          this.editData.push({
            id: item.taskid,
            label: item.task_title,
            notime: item.notime,
            backTime,
            newTime
          })
        }
      }
    },

    clickItem (item) {
      this.$taskDetail(item.taskid)
    },

    editSubmit (save) {
      this.editData.forEach(item => {
        if (save) {
          this.editLoad++
          let timeStart = item.newTime.start
          let timeEnd = item.newTime.end
          let ajaxData = {
            taskid: item.id,
            starttime: timeStart,
            endtime: timeEnd
          }
          let stask = this.list.find(task => task.taskid == item.id)
          ajaxData = Object.assign({}, stask, ajaxData)
          updateTaskApi(ajaxData).then(res => {
            if (!res.errno) {
              stask = Object.assign(stask, res.data)
              this.$message.success(res.message)
              this.editLoad--
            } else {
              this.$set(stask, 'starttime', item.backTime.start)
              this.$set(stask, 'endtime', item.backTime.end)
            }
          })
        } else {
          this.list.some(task => {
            if (task.taskid == item.id) {
              this.$set(task, 'starttime', item.backTime.start)
              this.$set(task, 'endtime', item.backTime.end)
              return true
            }
          })
        }
      })
      this.editData = []
    },

    getRawTime (taskId) {
      let times = null
      this.list.some(taskData => {
        if (taskData.taskid == taskId) {
          times = this.getTimeObj(taskData)
          return true
        }
      })
      return times
    },

    getTimeObj (taskData) {
      let start = taskData.starttime || taskData.createtime
      let end = taskData.endtime || taskData.createtime + 86400
      if (end == start) {
        end = Math.round(new Date($A.formatDate('Y-m-d 23:59:59', end)).getTime() / 1000)
      }
      end = Math.max(end, start + 60)
      start *= 1000
      end *= 1000
      return { start, end }
    }
  }
}
</script>

<style lang="scss">
.project-gstc-gantt {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 1;
  transform: translateZ(0);
  background-color: #fdfdfd;
  border-radius: 3px;
  overflow: hidden;

  .project-gstc-dropdown-filtr {
    position: absolute;
    top: 29px;
    left: 100px;

    .project-gstc-dropdown-icon {
      cursor: pointer;
      color: #999;
      font-size: 20px;

      &.filtr {
        color: #07c160;
      }
    }
  }

  .project-gstc-close {
    position: absolute;
    top: 8px;
    left: 12px;
    cursor: pointer;

    &:hover {
      i {
        transform: scale(1) rotate(45deg);
      }
    }

    i {
      color: #666666;
      font-size: 28px;
      transform: scale(0.92);
      transition: all 0.2s;
    }
  }

  .project-gstc-edit {
    position: absolute;
    bottom: 6px;
    right: 6px;
    background: #ffffff;
    border-radius: 4px;
    opacity: 0;
    transform: translate(120%, 0);
    transition: all 0.2s;

    &.visible {
      opacity: 1;
      transform: translate(0, 0);
    }

    &.info {
      .project-gstc-edit-info {
        display: block;
      }

      .project-gstc-edit-small {
        display: none;
      }
    }

    .project-gstc-edit-info {
      display: none;
      border: 1px solid #e4e4e4;
      background: #ffffff;
      padding: 6px;
      border-radius: 4px;
      width: 500px;

      .project-gstc-edit-btns {
        margin: 12px 6px 4px;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .ivu-btn {
          margin-right: 8px;
          font-size: 13px;
        }

        .zoom {
          font-size: 20px;
          color: #444444;
          cursor: pointer;

          &:hover {
            color: #57a3f3;
          }
        }
      }
    }

    .project-gstc-edit-small {
      border: 1px solid #e4e4e4;
      background: #ffffff;
      padding: 6px 12px;
      display: flex;
      align-items: center;

      .project-gstc-edit-text {
        cursor: pointer;
        text-decoration: underline;
        color: #444444;
        margin-right: 8px;

        &:hover {
          color: #57a3f3;
        }
      }

      .ivu-btn {
        margin-left: 4px;
        font-size: 13px;
      }
    }
  }
}
</style>